import { render, staticRenderFns } from "./FormattedDateField.vue?vue&type=template&id=fc51be6e&"
import script from "./FormattedDateField.vue?vue&type=script&lang=js&"
export * from "./FormattedDateField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc51be6e')) {
      api.createRecord('fc51be6e', component.options)
    } else {
      api.reload('fc51be6e', component.options)
    }
    module.hot.accept("./FormattedDateField.vue?vue&type=template&id=fc51be6e&", function () {
      api.rerender('fc51be6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/components/FormattedDateField.vue"
export default component.exports